module.exports = __webpack_public_path__ + "img/bg2.d1f83fa6.png";